/* eslint-disable consistent-return */
import { useResizeObserver, useWindowScroll } from '@folklore/hooks';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSpring, animated as a } from '@react-spring/web';

import Urbania from '../../icons/logos/Urbania';
import styles from '../../../../styles/blocks/employee/business-structure.module.scss';
import Detector from '../../partials/Detector';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            entries: PropTypes.arrayOf(
                PropTypes.shape({
                    title: PropTypes.string,
                    text: PropTypes.string,
                    color: PropTypes.string,
                }),
            ),
        }),
    ),
};

const defaultProps = {
    className: null,
    items: null,
};

const BusinessStructure = ({ className, items }) => {
    const { ref: containerRef } = useResizeObserver();
    const [scroll, setScroll] = useState(0);
    // const { y: scroll = 0 } = useWindowScroll();

    const [visible, setVisible] = useState(false);
    const [fixed, setFixed] = useState(false);
    const [firstDiagramVisible, setFirstDiagramVisible] = useState(true);
    const [secondDiagramVisible, setSecondDiagramVisible] = useState(false);

    const [brickPlopSpring, setBrickPlopSpring] = useSpring(
        () => ({
            y: '-50%',
            config: { tension: 160, friction: 15 },
        }),
        [],
    );

    // console.log(scroll);

    useEffect(() => {
        // if (visible) {

        const onScroll = () => {
            setScroll(window.scrollY);
        };
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    useEffect(() => {
        const { y: posY } = containerRef.current.getBoundingClientRect();

        if (posY < 20 && posY > -800) {
            setFixed(true);
        } else {
            setFixed(false);
        }
        if (posY < 20 && posY > -280) {
            setFirstDiagramVisible(true);
        } else if (posY < -280) {
            setFirstDiagramVisible(false);
        } else {
            setFirstDiagramVisible(true);
        }
        if (posY < -280 && posY > -800) {
            setSecondDiagramVisible(true);
            setBrickPlopSpring({
                y: '0',
                x: '0',
            });
        } else if (posY < -800) {
            setSecondDiagramVisible(true);
            setBrickPlopSpring({
                y: '0',
                x: '0',
            });
        } else {
            setSecondDiagramVisible(false);
            setBrickPlopSpring({
                y: '-100%',
                x: '0',
            });
        }
    }, [scroll, firstDiagramVisible, secondDiagramVisible]);

    return (
        <Detector rootMargin="-30%" onChange={(v) => setVisible(v)}>
            <a.div
                ref={containerRef}
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                {(items || []).map(({ title = null, image = null, entries = [] }, i) => {
                    const firstOpacity = visible && !firstDiagramVisible ? 0 : 1;
                    const secondOpacity = secondDiagramVisible ? 1 : 0;
                    const backgroundImageSpring = i === 1 ? brickPlopSpring : null;
                    const finalStyles = {
                        opacity: i === 0 ? firstOpacity : secondOpacity,
                        top: i === 0 && visible === false ? '0px' : '80px',
                    };

                    return (
                        <div
                            key={`diagram=${title}`}
                            className={classNames([
                                styles.diagram,
                                {
                                    [styles.fixed]: fixed === true,
                                },
                            ])}
                            style={finalStyles}
                        >
                            <a.div
                                className={styles.backgroundImageContainer}
                                style={{ ...backgroundImageSpring }}
                            >
                                <img
                                    src={image}
                                    alt={title}
                                    className={styles.backgroundImage}
                                    style={{
                                        transform:
                                            i === 0
                                                ? `translate(-50%, -50%) rotate(${scroll * 0.2}deg)`
                                                : null,
                                    }}
                                />
                            </a.div>
                            <a.div style={{ ...backgroundImageSpring }}>
                                <h4 className={styles.title}>{title}</h4>
                            </a.div>
                            <ul className={styles.entries}>
                                <Urbania color="white" className={styles.logo} />
                                {(entries || []).map(
                                    (
                                        {
                                            title: entryTitle = null,
                                            text = null,
                                            listItems = [],
                                            color = null,
                                        },
                                        entryI,
                                    ) => (
                                        <li
                                            key={`entries-${entryTitle}`}
                                            className={classNames([
                                                styles.entryContainer,
                                                {
                                                    [styles.horizontal]: entryI === 0,
                                                    [styles.monetisation]: i === 1,
                                                    [styles.visible]:
                                                        firstDiagramVisible || secondDiagramVisible,
                                                },
                                            ])}
                                        >
                                            <div className={styles.entryTitleContainer}>
                                                {/* <div
                                                    className={styles.numberBackground}
                                                    style={{
                                                        backgroundColor:
                                                            color !== null ? color : null,
                                                    }}
                                                /> */}
                                                {/* <div className={styles.number}>{entryI + 1}</div> */}
                                                <div
                                                    className={styles.entryTitle}
                                                    style={{
                                                        backgroundColor:
                                                            color !== null ? color : null,
                                                    }}
                                                >
                                                    <span style={{ fontSize: '22px' }}>
                                                        {entryI + 1}
                                                    </span>
                                                    <br />
                                                    {entryTitle}
                                                </div>
                                            </div>
                                            <div
                                                className={styles.text}
                                                style={{
                                                    backgroundColor: color !== null ? color : null,
                                                }}
                                            >
                                                {text}
                                                {listItems !== null ? (
                                                    <ul className={styles.textList}>
                                                        {(listItems || []).map((item, ind) => (
                                                            <li
                                                                key={`listItem-${ind + 1}`}
                                                                className={styles.textListItem}
                                                            >
                                                                {item}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : null}
                                            </div>
                                        </li>
                                    ),
                                )}
                            </ul>
                        </div>
                    );
                })}
            </a.div>
        </Detector>
    );
};

BusinessStructure.propTypes = propTypes;
BusinessStructure.defaultProps = defaultProps;

export default BusinessStructure;
